var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uni-popup-message"},[_c('div',{staticClass:"uni-popup-message__box fixforpc-width",class:'uni-popup__' + _vm.type},[_vm._t("default",function(){return [_c('span',{staticClass:"uni-popup-message-text",class:'uni-popup__' + _vm.type + '-text'},[_vm._v(_vm._s(_vm.message))])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }